/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './sites.scss';

/* eslint-disable import/no-unresolved, import/default */

import sitesTemplate from './sites.tpl.html';
import addSiteTemplate from './../../admin/site/add-site.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.common.sites', [])
    .directive('agSites', Sites)
    .name;

/*@ngInject*/
function Sites() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: SitesController,
        controllerAs: 'vm',
        templateUrl: sitesTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function SitesController($rootScope, $scope, $document, $mdDialog, $q, $filter, $mdMedia,
                              $translate, agTypes, types, userService, siteService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' ||
                  userService.getAuthority() === 'CUSTOMER_USER';
    vm.hasData = false;

    vm.sites = [];
    vm.sitesCount = 0;
    vm.allSites = [];
    vm.selectedSites = [];

    vm.isClientMode = true;
    vm.displayPagination = true;

    vm.currentSite = null;

    vm.query = {
        order: 'name',
        limit: 10,
        page: 1,
        search: null
    };

    vm.addSiteAction = {
        name: 'ag.site.add',
        show: true,
        onAction: function($event) {
            vm.addSite($event);
        },
        icon: 'add'
    };

    vm.searchAction = {
        name: 'action.search',
        show: true,
        onAction: function() {
            vm.enterFilterMode();
        },
        icon: 'search'
    };

    vm.refreshAction = {
        name: 'action.refresh',
        show: true,
        onAction: function() {
            vm.reloadSites();
        },
        icon: 'refresh'
    };

    vm.onRowClick = onRowClick;
    vm.isCurrent = isCurrent;
    vm.enterFilterMode = enterFilterMode;
    vm.exitFilterMode = exitFilterMode;
    vm.onReorder = onReorder;
    vm.onPaginate = onPaginate;
    vm.addSite = addSite;
    vm.gotoSiteDetails = gotoSiteDetails;
    vm.deleteSite = deleteSite;
    vm.deleteSites = deleteSites;
    vm.reloadSites = reloadSites;
    vm.updateSites = updateSites;

    $scope.$watch(function() { return $mdMedia('gt-xs'); }, function(isGtXs) {
        vm.isGtXs = isGtXs;
        if (vm.isGtXs) {
            vm.limitOptions = [5, 10, 15];
        } else {
            vm.limitOptions = null;
        }
    });

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            if (vm.ctx.settings) {
                if (angular.isDefined(vm.ctx.settings.isClientMode)) {
                    vm.isClientMode = vm.ctx.settings.isClientMode;
                }
                vm.ctx.widgetActions = [ vm.addSiteAction, vm.searchAction, vm.refreshAction ];
                vm.addSiteAction.show = !vm.isClientMode;
                vm.ctx.widgetTitle = $translate.instant('ag.site.sites') + '';
                vm.displayPagination = angular.isDefined(vm.ctx.settings.displayPagination) ? vm.ctx.settings.displayPagination : true;
            }
            var currentSiteId = null;
            if (!vm.isClientMode && vm.ctx.stateController.getStateId() === agTypes.adminState.sites) {
                currentSiteId = vm.ctx.stateController.getStateParams().entityId;
            }
            reloadSites(currentSiteId);
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$watch("vm.query.search", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal) && vm.query.search != null) {
            updateSites();
        }
    });

    $scope.$watch("vm.currentSite", function(newVal, prevVal) {
        if (!angular.equals(newVal, prevVal)) {
            var siteId = vm.currentSite ? vm.currentSite.id : null;
            $rootScope.$broadcast('siteSelected', siteId);
        }
    });

    $scope.$on('siteSelected', function(event, siteId) {
        if (siteId) {
            var result = $filter('filter')(vm.allSites, {id: { id: siteId.id } }, true);
            if (result && result.length) {
                var newCurrentSite = result[0];
                vm.currentSite = newCurrentSite;
            }
        }
    });

    $scope.$on('siteUpdated', function(event, site) {
        var result = $filter('filter')(vm.allSites, {id: {id: site.id.id}}, true);
        if (result && result.length) {
            var prevSite = result[0];
            var index = vm.allSites.indexOf(prevSite);
            vm.allSites[index] = site;
            index = vm.sites.indexOf(prevSite);
            if (index > -1) {
                vm.sites[index] = site;
            }
        }
    });

    $scope.$watch('vm.selectedSites.length', function (newLength) {
        var selectionMode = newLength ? true : false;
        if (vm.ctx) {
            if (selectionMode) {
                vm.ctx.hideTitlePanel = true;
            } else if (vm.query.search == null) {
                vm.ctx.hideTitlePanel = false;
            }
        }
    });

    function onRowClick($event, site) {
        if ($event) {
            $event.stopPropagation();
        }
        var params = {
            entityId: site.id
        };
        if (vm.isClientMode) {
            vm.ctx.stateController.openState(agTypes.clientState.site, params);
        } else {
            if (vm.ctx.stateController.getStateId() === agTypes.adminState.system) {
                vm.ctx.stateController.openState(agTypes.adminState.sites, params);
            } else {
                if (vm.currentSite !== site) {
                    vm.currentSite = site;
                }
                if (vm.ctx.stateController.getStateId() === agTypes.adminState.sites) {
                    vm.ctx.stateController.updateState(agTypes.adminState.sites, params, true);
                } else {
                    vm.ctx.stateController.openRightLayout();
                }
            }
        }
    }


    function isCurrent(site) {
        return (vm.currentSite && site) &&
            (vm.currentSite.id.id === site.id.id);
    }

    function enterFilterMode () {
        vm.query.search = '';
        vm.ctx.hideTitlePanel = true;
    }

    function exitFilterMode () {
        vm.query.search = null;
        updateSites();
        vm.ctx.hideTitlePanel = false;
    }

    function onReorder () {
        updateSites();
    }

    function onPaginate () {
        updateSites();
    }

    function addSite($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: AddSiteController,
            controllerAs: 'vm',
            templateUrl: addSiteTemplate,
            parent: angular.element($document[0].body),
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
            reloadSites();
        }, function () {
        });
    }

    function gotoSiteDetails($event, site) {
        if ($event) {
            $event.stopPropagation();
        }
        var params = {
            entityId: site.id
        };
        vm.ctx.stateController.openState(agTypes.adminState.site, params);
    }

    function deleteSite($event, site) {
        if ($event) {
            $event.stopPropagation();
        }
        if (site) {
            var title = $translate.instant('ag.site.delete-site-title', {siteName: site.name});
            var content = $translate.instant('ag.site.delete-site-text');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                siteService.deleteSite(site.id).then(
                    function success() {
                        reloadSites();
                    }
                );
            });
        }
    }

    function deleteSites($event) {
        if ($event) {
            $event.stopPropagation();
        }
        if (vm.selectedSites && vm.selectedSites.length > 0) {
            var title = $translate.instant('ag.site.delete-sites-title', {count: vm.selectedSites.length}, 'messageformat');
            var content = $translate.instant('ag.site.delete-sites-text');
            var confirm = $mdDialog.confirm()
                .targetEvent($event)
                .title(title)
                .htmlContent(content)
                .ariaLabel(title)
                .cancel($translate.instant('action.no'))
                .ok($translate.instant('action.yes'));
            $mdDialog.show(confirm).then(function () {
                var tasks = [];
                for (var i=0;i<vm.selectedSites.length;i++) {
                    var site = vm.selectedSites[i];
                    tasks.push(siteService.deleteSite(site.id));
                }
                $q.all(tasks).then(function () {
                    reloadSites();
                });

            });
        }
    }

    function reloadSites (currentSiteId) {
        vm.allSites.length = 0;
        vm.sites.length = 0;
        vm.currentSite = null;
        vm.sitesPromise = siteService.getCustomerSites();
        vm.sitesPromise.then(
            function success(allSites) {
                vm.allSites = allSites;
                vm.selectedSites = [];
                vm.updateSites(currentSiteId);
                vm.sitesPromise = null;
            },
            function fail() {
                vm.allSites = [];
                vm.selectedSites = [];
                vm.updateSites();
                vm.sitesPromise = null;
            }
        )
    }

    function updateSites (currentSiteId) {
        vm.selectedSites = [];
        var result = $filter('orderBy')(vm.allSites, vm.query.order);
        if (vm.query.search != null) {
            result = $filter('filter')(result, {$: vm.query.search});
        }
        vm.sitesCount = result.length;
        if (vm.displayPagination) {
            var startIndex = vm.query.limit * (vm.query.page - 1);
            vm.sites = result.slice(startIndex, startIndex + vm.query.limit);
        } else {
            vm.sites = result;
        }
        if (currentSiteId) {
            result = $filter('filter')(vm.sites, {id: { id: currentSiteId.id } }, true);
            if (result && result.length) {
                vm.currentSite = result[0];
            }
        }
    }

}

/*@ngInject*/
function AddSiteController($scope, $mdDialog, types, agTypes, siteService) {

    var vm = this;

    vm.site = {
        id: {
            entityType: types.entityType.asset
        },
        type: agTypes.assetType.site
    };

    vm.add = add;
    vm.cancel = cancel;

    function cancel() {
        $mdDialog.cancel();
    }

    function add() {
        if ($scope.theForm.updateValidity()) {
            siteService.saveSite(vm.site).then(function success(site) {
                vm.site = site;
                $scope.theForm.$setPristine();
                $mdDialog.hide();
            });
        }
    }
}